/*
  F&NT · Nombre corto en listas (v12, 24 sep 2026; v25, 15 oct: también detecta textos cambiados)
  Los títulos de producto son "Nombre · Subtítulo" (SEO). La ficha y las tarjetas ya muestran solo el
  nombre desde Liquid (snippets/fnt-titulo.liquid). Este script hace lo mismo en los lugares que se pintan
  con el título completo y viven en archivos grandes del tema: recomendados del carrito (.fnt-up__name),
  líneas del carrito (.cart-items__title), barra fija (.fnt-satc__name), promo de colección (.fntc-promo__name)
  y cualquier enlace a producto con texto simple (menús, píldoras).
  Solo toca elementos sin hijos cuyo texto trae " · ". Lo carga snippets/fnt-mega-menu.liquid (todas las páginas).
  v25: el carrito a veces se redibuja cambiando solo el texto (al aplicar un código); por eso también escucha
  characterData. Las líneas del carrito ya salen cortas desde snippets/cart-products.liquid.
  Deuda: pasarlo a Liquid (split: ' · ' | first) cuando se editen esos archivos.
*/
(function () {
  if (window.__fntTitulos) return;
  window.__fntTitulos = true;

  var SEL = '.fnt-up__name, .cart-items__title, .fnt-satc__name, .fntc-promo__name, a[href*="/products/"]';
  var SEP = ' · ';

  function corto() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.children.length) return;
      var t = el.textContent;
      var i = t.indexOf(SEP);
      if (i > -1) el.textContent = t.slice(0, i).trim();
    });
  }

  var pendiente = false;
  function programar() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; corto(); });
  }

  function start() {
    corto();
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        if (ms[i].type === 'characterData' || ms[i].addedNodes.length) { programar(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
